// extracted by mini-css-extract-plugin
export default {"reminderForm":"style_reminderForm__roc9b","reminderButton":"style_reminderButton__k5H+O","title":"style_title__dmmKf","text":"style_text__Dj1BL"};